import _ from 'lodash';
import I18n from '../i18n/I18n'

const PaymentMethod = {
  /**
   * user CB
   * Paypal
   * etc
   */
  PAYMENT: 'PAYMENT',

  /**
   * payment by user account.
   */
  USER_ACCOUNT: 'USER_ACCOUNT',

  /**
   * the payment has been made IRL (kiosk TPE)
   */
  IRL_PAYMENT: 'IRL_PAYMENT',

  NOT_PRE_PAYED: 'NOT_PRE_PAYED',

}

export const getPaymentMethodOptions = () => (
  _.keys(PaymentMethod).map((value) => {
  return {
    label: I18n.tr(`payments.method.${value}`),
    value,
  }
  })
)

export default PaymentMethod



// WEBPACK FOOTER //
// ./sdk/scripts/constants/PaymentMethod.js